import React from 'react';
import { Link } from 'react-router-dom';
import { IsoIllustration } from '../components/iso/IsoSvg';
import { Icon } from '../components/ui';
import usePageTitle from '../hooks/usePageTitle';

export default function NotFoundPage() {
  usePageTitle('Page not found');
  return (
    <div className="wrap" style={{ padding: '80px 0 100px', textAlign: 'center' }}>
      <div style={{ width: 300, maxWidth: '80%', margin: '0 auto 24px' }}>
        <IsoIllustration scene="lost" />
      </div>
      <div className="kicker kicker--spark" style={{ justifyContent: 'center' }}>404 · off the sheet</div>
      <h1 style={{ fontSize: 'var(--t-h2)', fontWeight: 800, marginTop: 12 }}>This page got cut from the nest.</h1>
      <p className="muted-2" style={{ marginTop: 12, maxWidth: '46ch', marginInline: 'auto' }}>
        The link may be out of date or the page has moved. Try the home page, or search for what you need.
      </p>
      <div className="row" style={{ justifyContent: 'center', marginTop: 26, gap: 10, flexWrap: 'wrap' }}>
        <Link to="/" className="btn btn-p"><Icon name="home" />Back home</Link>
        <Link to="/search" className="btn btn-s"><Icon name="search" />Search</Link>
      </div>
    </div>
  );
}
